const customSpellImages: Record<string, Record<string, string>> = {
    LeBlanc: {
      w_return: 'https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancwreturn.png',
      r_q: 'https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancrq.png',
      r_w: 'https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancrw.png',
      r_e: 'https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancre.png',
      r_w_return: 'https://raw.communitydragon.org/latest/game/assets/characters/leblanc/hud/icons2d/leblancrwreturn.png'
    },
    Jinx: {
      q_pow_pow: 'https://raw.communitydragon.org/latest/game/assets/characters/jinx/hud/icons2d/jinx_q2.png',
    }
    // Add more champions and their custom images as needed
  };

    export default customSpellImages;